/**
 *
 * @Pattern https://mgechev.github.io/angularjs-in-patterns/#facade
 */

export default function Resources(ResourceService, ResourceFactory) {
    var fn = this;

    fn.entries = [];
    /**
     * API v3
     */

    fn.get = (id) => {
        return ResourceService.get(id);
    };

    fn.getAll = () => {
        return ResourceService.getAll();
    };

    fn.getEntries = (id, start, end) => {
        return ResourceService.getEntries(id, start, end);
    };

    fn.getDependencies = () => {
        return ResourceService.getDependencies();
    };

    /**
     * factory functions
     */

    fn.lookupLaneDependencies = (resourceId, dependencies) => {
        return ResourceFactory.lookupLaneDependencies(resourceId, dependencies);
    };

    fn.lookupResource = (id, resources) => {
        return ResourceFactory.lookupResource(id, resources);
    };

    return fn;
}
